import { ReconBankPoolFileDetailPage } from "@/features/recon-bank/pages/ReconBankPoolFileDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank-upload/$id/detail")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconBankPoolFileDetailPage,
});
